import axios from 'axios'

export const DASHBOARD_URL = `${process.env.REACT_APP_API_URL}/dashboard`

export const getStatistics = async () => {
  const response = await axios.post(`${DASHBOARD_URL}/getstatistics`, {})
  return response
}

export const syncStatistics = async () => {
  // POST to /dashboard/sync endpoint
  return axios.post(`${DASHBOARD_URL}/sync`)
}
